import { render } from "./ButtonKana.vue?vue&type=template&id=04fc8ad5&scoped=true"
import script from "./ButtonKana.vue?vue&type=script&lang=js"
export * from "./ButtonKana.vue?vue&type=script&lang=js"

import "./ButtonKana.vue?vue&type=style&index=0&id=04fc8ad5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fc8ad5"]])

export default __exports__